module.exports = __webpack_public_path__ + "static/media/report.638b939b.png";